import { render, staticRenderFns } from "./step4CnCom.vue?vue&type=template&id=55077242&scoped=true"
import script from "./step4CnCom.vue?vue&type=script&lang=js"
export * from "./step4CnCom.vue?vue&type=script&lang=js"
import style0 from "./step4CnCom.vue?vue&type=style&index=0&id=55077242&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55077242",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55077242')) {
      api.createRecord('55077242', component.options)
    } else {
      api.reload('55077242', component.options)
    }
    module.hot.accept("./step4CnCom.vue?vue&type=template&id=55077242&scoped=true", function () {
      api.rerender('55077242', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/guidance/steps/step4CnCom.vue"
export default component.exports